import axios from 'axios'

const ClosingService = {
  async get (params = {}) {
    return axios.get('lo/delivery-closings', { params })
  },

  async histories (params = {}) {
    return axios.get('lo/reports/delivery-closing-histories', { params })
  },

  async show (id) {
    return axios.get(`lo/delivery-closings/${id}`)
  },

  async post (params = {}) {
    return axios.post('lo/delivery-closings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`lo/delivery-closings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`lo/delivery-closings/${data.id}`, { data })
  }
}

export default ClosingService
